let probe;

// Canvas 2D (and therefore ECharts, which renders via canvas by default)
// never resolves CSS custom properties — ctx.fillStyle/strokeStyle silently
// ignore a `var(--x)` string (or a color-mix()/etc. expression referencing
// one) and fall back to black. Resolve to the literal computed value before
// handing a color into an ECharts option. Assigning to a detached probe
// element's `color` and reading it back via getComputedStyle lets the
// browser resolve any valid CSS color syntax, not just a bare var(--x).
export function resolveCssVar(value) {
  if (typeof value !== 'string' || !value.includes('var(')) return value;
  if (!probe) {
    probe = document.createElement('span');
    probe.style.display = 'none';
    document.body.appendChild(probe);
  }
  probe.style.color = '';
  probe.style.color = value;
  const resolved = getComputedStyle(probe).color;
  return resolved || value;
}
